import React from "react";
import PageFrame from "./PageFrame";
import {
    Sun, CloudRain, ShieldCheck, Thermometer, Users,
    HeartPulse, Wifi, Landmark
} from "lucide-react";

const ICONS = {
    "No State Income Tax": Landmark,
    "Hurricane Season": CloudRain,
    "Home Insurance": ShieldCheck,
    "Summer Heat": Thermometer,
    "Military Community": Users,
    "Healthcare": HeartPulse,
    "Internet & Remote Work": Wifi,
    "Property Tax": Sun,
};

export default function EssentialsPage({ essentials, pageNum, totalPages }) {
    return (
        <PageFrame pageNum={pageNum} totalPages={totalPages} label="Essentials">
            <div className="max-w-6xl mx-auto px-6 sm:px-10 lg:px-16 py-16 sm:py-24 w-full">
                <div className="eyebrow">Before You Move</div>
                <h2 className="serif-display text-5xl sm:text-6xl text-navy mt-4 mb-12">
                    Florida Panhandle essentials.
                </h2>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-px bg-hairline border border-hairline">
                    {essentials.map((e) => (
                        <EssentialCard key={e.label} label={e.label} body={e.body} />
                    ))}
                </div>
            </div>
        </PageFrame>
    );
}

function EssentialCard({ label, body }) {
    const Icon = ICONS[label] || Sun;
    return (
        <div className="bg-cream p-7 transition-colors hover:bg-white">
            <div className="flex items-start gap-4">
                <div className="w-10 h-10 rounded-sm bg-navy text-cream flex items-center justify-center flex-shrink-0">
                    <Icon size={18} />
                </div>
                <div>
                    <h3 className="serif-display text-2xl text-navy mb-2 leading-tight">
                        {label}
                    </h3>
                    <p className="text-ink/85 leading-relaxed">{body}</p>
                </div>
            </div>
        </div>
    );
}
